export const JAR_TYPES = {
  crema_giorno: { icon: 'sun', nameKey: 'store.day_cream', label: ['CREMA GIORNO', 'DAY CREAM'] },
  crema_notte: { icon: 'moon', nameKey: 'store.night_cream', label: ['CREMA NOTTE', 'NIGHT CREAM'] },
  siero_antiage: { icon: 'hourglass', nameKey: 'store.antiage_serum', label: ['SIERO ANTIAGE', 'ANTIAGE SERUM'] },
  contorno_occhi: { icon: 'eye', nameKey: 'store.eye_contour', label: ['CONTORNO OCCHI', 'EYE CONTOUR'] },
  contorno_labbra: { icon: 'lips', nameKey: 'store.lip_contour', label: ['CONTORNO LABBRA', 'LIP CONTOUR'] },
};

export const JAR_TYPE_ORDER = Object.keys(JAR_TYPES);

export const LINE_ORDER = ['pink', 'green', 'blue', 'orange'];

export const HERO_JARS = [
  { color: 'green', type: 'crema_giorno' },
  { color: 'pink', type: 'crema_notte' },
  { color: 'pink', type: 'siero_antiage' },
  { color: 'orange', type: 'contorno_occhi' },
  { color: 'blue', type: 'contorno_labbra' },
].map((j) => ({ ...j, ...JAR_TYPES[j.type] }));

export const easeInOut = (t) => {
  const x = Math.min(Math.max(t, 0), 1);
  return x < 0.5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
};
